<div *ngIf="loading">
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <div class="loading-text">Loading...</div>
  </div>
</div>

<div *ngIf="!loading" class="switch-item-block-manager">
  <!-- Header Bar -->
  <div
    class="table-header-bar"
    [ngClass]="{ 'is-stack': vm.isStack, 'is-block': !vm.isStack }"
  >
    <div class="header-left">
      <span class="stack-name">{{ vm.assetName || "STACK-Lband IPL25" }}</span>
    </div>
    <div class="header-right">
      <span class="total-duration">{{ getTotalDuration() }}</span>
    </div>
  </div>

  <!-- Middle Content Area - This will grow to fill available space -->
  <div class="table-content-wrapper">
    <!-- Table -->
    <div class="table-container">
      <table
        class="playlist-table"
        [class.is-stack]="vm.isStack"
        [class.is-block]="vm.isBlock"
      >
        <colgroup>
          <col class="col-drag" />
          <col class="col-name" />
          <col class="col-play-time" *ngIf="!vm.isBlock" />
          <col class="col-duration" />
          <col class="col-played" *ngIf="!vm.isBlock" />
          <col class="col-mute" *ngIf="!vm.isBlock" />
          <col class="col-hide" *ngIf="!vm.isBlock" />
        </colgroup>
        <thead>
          <tr>
            <th class="drag-handle"></th>
            <th class="name-column">NAME</th>
            <th class="play-time-column" [hidden]="this.vm.isBlock">
              PLAY TIME
            </th>
            <th class="duration-column">DURATION</th>
            <th class="played-column" [hidden]="this.vm.isBlock">% PLAYED</th>
            <th class="mute-audio-column" [hidden]="this.vm.isBlock">
              <span class="checkbox-column-header">
                <input
                  type="checkbox"
                  [checked]="areAllItemsMuted()"
                  [disabled]="isStackEditingDisabled"
                  (change)="onMuteAllAudioChange($event.target.checked)"
                  (click)="$event.stopPropagation()"
                  [title]="
                    areAllItemsMuted()
                      ? 'UNMUTE FOR ALL STACK ITEMS'
                      : 'MUTE FOR ALL STACK ITEMS'
                  "
                />
                <span class="checkbox-column-header__label"
                  >MUTE MAIN VIDEO AUDIO</span
                >
              </span>
            </th>
            <th class="hide-logo-column" [hidden]="this.vm.isBlock">
              <span class="checkbox-column-header">
                <input
                  type="checkbox"
                  [checked]="areAllItemsLogoHidden()"
                  [disabled]="isStackEditingDisabled"
                  (change)="onHideAllLogoChange($event.target.checked)"
                  (click)="$event.stopPropagation()"
                  [title]="
                    areAllItemsLogoHidden()
                      ? 'SHOW CHANNEL LOGO FOR ALL STACK ITEMS'
                      : 'HIDE CHANNEL LOGO FOR ALL STACK ITEMS'
                  "
                />
                <span class="checkbox-column-header__label"
                  >HIDE CHANNEL LOGO</span
                >
              </span>
            </th>
          </tr>
        </thead>
        <tbody #tableBody>
          <ng-container *ngFor="let item of playlistItems; let i = index">
          <!-- Group header row -->
          <tr
            *ngIf="vm.isStack && isGroupHead(item.id)"
            class="group-header-row"
            [style.--group-color]="getGroupColor(item.id)"
            draggable="false"
            (dragstart)="$event.preventDefault(); $event.stopPropagation()"
            (click)="$event.stopPropagation()"
          >
            <td [attr.colspan]="columnCount" class="group-header-cell">
              <div class="group-header-cell__inner">
                <span
                  class="group-color-dot"
                  [style.background]="getGroupColor(item.id)"
                  (click)="cycleGroupColor(item.id); $event.stopPropagation()"
                  title="Click to cycle colour"
                ></span>
                <input
                  class="group-label-input"
                  [value]="getGroupLabel(item.id)"
                  (input)="updateGroupLabelInMemory(item.id, $event.target.value)"
                  (blur)="saveGroupLabel(item.id)"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                  placeholder="Group name…"
                />
                <button
                  class="group-remove-btn"
                  (click)="removeGroup(item.id); $event.stopPropagation()"
                  title="Remove group divider"
                >✕</button>
              </div>
            </td>
          </tr>
          <!-- Data row -->
          <tr
            [ngClass]="getRowClass(item, i)"
            [class.in-group]="vm.isStack && isInGroup(item.id)"
            [class.stack-editing-disabled]="isStackEditingDisabled"
            [style.--group-color]="vm.isStack ? getRowGroupColor(item.id) : null"
            (click)="selectItem(item)"
            (contextmenu)="onRowContextMenu($event, item)"
            [draggable]="vm.isStack && !isStackEditingDisabled"
            (dragstart)="this.vm.isStack ? onDragStart($event, item) : null"
            (dragend)="this.vm.isStack ? onDragEnd($event) : null"
            (dragover)="this.vm.isStack ? onDragOver($event) : null"
            (dragenter)="this.vm.isStack ? onDragEnter($event, item) : null"
            (dragleave)="this.vm.isStack ? onDragLeave($event) : null"
            (drop)="this.vm.isStack ? onDrop($event, item) : null"
          >
            <td class="drag-handle">
              <div
                class="drag-icon"
                [class.drag-icon--disabled]="isStackEditingDisabled"
                [hidden]="this.vm.isBlock"
              >⋮⋮</div>
            </td>
            <td class="name-column" [title]="item.name">
              <span class="name-column__text">{{ item.name }}</span>
            </td>
            <td class="play-time-column" [hidden]="this.vm.isBlock">
              {{ item.playTime || "NA" }}
            </td>
            <td class="duration-column">{{ item.duration }}</td>
            <td class="played-column" [hidden]="this.vm.isBlock">
              {{ item.playedPercentage || "NA" }}
            </td>
            <td class="mute-audio-column" [hidden]="this.vm.isBlock">
              <span class="checkbox-cell">
                <input
                  type="checkbox"
                  [checked]="isItemMuted(item.id)"
                  [disabled]="isStackEditingDisabled"
                  (change)="onMuteAudioChange($event.target.checked, item.id)"
                  (click)="$event.stopPropagation()"
                />
              </span>
            </td>
            <td class="hide-logo-column" [hidden]="this.vm.isBlock">
              <span class="checkbox-cell">
                <input
                  type="checkbox"
                  [checked]="isItemLogoHidden(item.id)"
                  [disabled]="isStackEditingDisabled"
                  (change)="onHideLogoChange($event.target.checked, item.id)"
                  (click)="$event.stopPropagation()"
                />
              </span>
            </td>
          </tr>
          <!-- Group end separator line -->
          <tr
            *ngIf="vm.isStack && isGroupEnd(item.id)"
            class="group-end-separator"
            [style.--group-color]="getRowGroupColor(item.id)"
            draggable="false"
            (dragstart)="$event.preventDefault(); $event.stopPropagation()"
          >
            <td [attr.colspan]="columnCount" class="group-end-separator-cell"></td>
          </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="thumbnail-container">
      <div
        *ngIf="selectedItem"
        [ngStyle]="{
          'background-image': 'url(' + selectedItem.thumbnail + ')',
        }"
      ></div>
    </div>
  </div>

  <!-- Group context menu -->
  <div
    class="group-context-menu"
    *ngIf="showGroupContextMenu"
    [style.left.px]="groupContextMenuPosition.x"
    [style.top.px]="groupContextMenuPosition.y"
    (click)="$event.stopPropagation()"
  >
    <!-- Start group (only if this item is not already a head) -->
    <div
      class="group-context-menu__item"
      *ngIf="!isGroupHead(groupContextMenuTargetId)"
      (click)="onStartGroupClick()"
    >
      Start group from here
    </div>
    <!-- End group (only if inside a group, not the head, and not already the end) -->
    <div
      class="group-context-menu__item"
      *ngIf="!isGroupHead(groupContextMenuTargetId) && isInGroup(groupContextMenuTargetId) && !isGroupEnd(groupContextMenuTargetId)"
      (click)="onEndGroupHereClick()"
    >
      End group here
    </div>
    <!-- Remove group end (only if this item is a group end marker) -->
    <div
      class="group-context-menu__item group-context-menu__item--muted"
      *ngIf="isGroupEnd(groupContextMenuTargetId)"
      (click)="onRemoveGroupEndClick()"
    >
      Remove group end
    </div>
    <!-- Separator before destructive action -->
    <div
      class="group-context-menu__separator"
      *ngIf="isGroupHead(groupContextMenuTargetId)"
    ></div>
    <!-- Remove group divider (only heads) -->
    <div
      class="group-context-menu__item group-context-menu__item--danger"
      *ngIf="isGroupHead(groupContextMenuTargetId)"
      (click)="onRemoveGroupFromContextMenu()"
    >
      Remove group
    </div>
  </div>

  <!-- Action Bar - This will stick to the bottom -->
  <div class="action-bar">
    <!-- Left side - Mode buttons -->
    <div class="action-bar__mode-buttons">
      <button
        class="action-bar__mode-btn action-bar__mode-btn--preview"
        [ngClass]="{ active: vm.isPreview }"
        (click)="onPreviewClicked.emit($event)"
      >
        Preview
      </button>
      <button
        class="action-bar__mode-btn action-bar__mode-btn--program"
        [ngClass]="{ active: vm.isProgram }"
        (click)="onProgramClicked.emit($event)"
      >
        Program
      </button>
    </div>

    <!-- Right side - Toggle control -->
    <div
      class="action-bar__toggle-section"
      [class.grayed-out]="vm.isProgram || vm.isPreview"
    >
      <evrideo-tot-sliding-toggle
        [default]="vm.isStack ? 'that' : 'this'"
        [this]="'Block'"
        [that]="'Stack'"
        (its)="changeBlockType.emit()"
      >
      </evrideo-tot-sliding-toggle>
    </div>
  </div>
</div>
